module.exports = __webpack_public_path__ + "img/product_1.e290d4b.webp";